import { render, staticRenderFns } from "./OtherProducts.vue?vue&type=template&id=529268da&scoped=true"
import script from "./OtherProducts.vue?vue&type=script&lang=js"
export * from "./OtherProducts.vue?vue&type=script&lang=js"
import style0 from "./OtherProducts.vue?vue&type=style&index=0&id=529268da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529268da",
  null
  
)

export default component.exports